import React, { useState, useEffect } from 'react';
import {
  Snackbar,
  Alert,
  Button,
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const LogoutNotification = () => {
  const { user } = useAuth();
  const [showLogoutMessage, setShowLogoutMessage] = useState(false);
  const [wasLoggedIn, setWasLoggedIn] = useState(false);

  useEffect(() => {
    if (user) {
      setWasLoggedIn(true);
      setShowLogoutMessage(false);
    } else if (wasLoggedIn && !user) {
      // User was logged in but now is not - show logout message
      setShowLogoutMessage(true);
    }
  }, [user, wasLoggedIn]);

  const handleClose = () => {
    setShowLogoutMessage(false);
  };

  const handleLoginRedirect = () => {
    setShowLogoutMessage(false);
    window.location.href = '/login';
  };

  return (
    <Snackbar
      open={showLogoutMessage}
      autoHideDuration={10000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        severity="warning"
        onClose={handleClose}
        action={
          <Button color="inherit" size="small" onClick={handleLoginRedirect}>
            Login Again
          </Button>
        }
      >
        Your session has expired. Please log in again to continue.
      </Alert>
    </Snackbar>
  );
};

export default LogoutNotification;
